import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CMFlex } from "@chartmetric/chartmetric-design-system/components/CMFlex";
import { CMText } from "@chartmetric/chartmetric-design-system/components/CMText";
import { CMButton } from "@chartmetric/chartmetric-design-system/components/CMButton";

function NotFoundPage() {
  const { t } = useTranslation("common", { keyPrefix: "site" });
  const navigate = useNavigate();

  return (
    <CMFlex vertical align="center" justify="center" gap="sm" p="md" height="min-h-[60vh]">
      <CMText value={t("notFoundTitle")} variant="h2" />
      <CMText value={t("notFoundDescription")} variant="mini-1" color="tertiary" />
      <CMButton
        text={t("backHome")}
        variant="primary"
        size="sm"
        onClick={() => navigate("/")}
      />
    </CMFlex>
  );
}

export default NotFoundPage;
